import React, { Component } from "react";
import {
	Dialog,
	DialogContent,
	TextField,
	Button,
	CircularProgress,
	withStyles,
} from "@material-ui/core";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Dialog as Dialog2 } from "@progress/kendo-react-dialogs";
import { FormattedMessage, injectIntl } from "react-intl";
import NoAuthorization from "../../../helpers/noAuthorization";
import NoSuccess from "../../../helpers/notSuccess";
import { Field, reduxForm } from "redux-form";
import MultiSelectFilter from "../../MultiSelectFilter";
import BadRequest from "../../../helpers/badRequest";
import { Slide } from "@progress/kendo-react-animation";

const validate = (values) => {
	const errors = {};
	const requiredFields = ["name"];

	requiredFields.forEach((field) => {
		if (!values[field])
			errors[field] = (
				<FormattedMessage
					id='validation.required'
					defaultMessage={`This field is required`}
				/>
			);
	});

	return errors;
};
const styles = (theme) => ({
	dialogContent: {
		width: "600px",
	},
});

export class cdForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showConfirm: false,
			data: this.props.dataKpi.data,
			value: [],
			badRequest: false,
			badRequestResponse: null,
		};
	}

	renderTextField = ({
		label,
		input,
		meta: { touched, invalid, error },
		...custom
	}) => (
		<TextField
			fullWidth
			label={label}
			placeholder={label}
			error={touched && invalid}
			helperText={touched && error}
			{...input}
			{...custom}
		/>
	);

	callbackKPI = (value) => {
		this.setState({ value: value });
	};

	convertLoadData = (values) => {
		let array = [];
		if (values !== []) {
			values.forEach((field) => {
				this.props.dataKpi.data.forEach((e) => {
					if (field.title === e.name) {
						array.push(e);
					}
				});
			});
		}
		return array;
	};

	componentDidMount() {
		if (this.props.selectedData.length !== 0) {
			this.props.change("name", this.props.selectedData.name);
			this.setState({
				value: this.convertLoadData(this.props.selectedData.dashboardWidgets),
			});
		}
	}

	confirmMessage = (status, save) => {
		if (this.state.showConfirm) {
			let comp = <div></div>;
			if (status === "loading") {
				comp = <CircularProgress></CircularProgress>;
			} else {
				comp = (
					<DialogActionsBar>
						<button
							className='k-button'
							onClick={() => {
								this.setState({ showConfirm: !this.state.showConfirm });
							}}
						>
							<FormattedMessage id='no' defaultMessage='No'></FormattedMessage>
						</button>
						<button
							className='k-button'
							style={{ color: "blue" }}
							onClick={() => {}}
						>
							<FormattedMessage
								id='yes'
								defaultMessage='Yes'
							></FormattedMessage>
						</button>
					</DialogActionsBar>
				);
			}
			return (
				<Dialog2
					title={this.props.intl.formatMessage({
						id: "deleteConfirm",
						defaultMessage: "Please confirm",
					})}
					onClose={() => {
						this.setState({ showConfirm: !this.state.showConfirm });
					}}
				>
					{this.props.deniedDelete && <NoAuthorization />}
					{this.props.requestError && <NoSuccess />}

					<p style={{ margin: "25px", textAlign: "center" }}>
						<FormattedMessage
							id='messageSave'
							defaultMessage='Do you wish to save changes?'
						></FormattedMessage>
					</p>
					{comp}
				</Dialog2>
			);
		}
	};

	validation = () => {
		let objError = {
			data: {
				errors: {},
				title: this.props.intl.formatMessage({ id: 'error.model', defaultMessage: 'One or more model validation errors ocurred' }),
			},
		};

		const name = document.getElementsByName("name")[0].value;
		const kpis = this.state.value;

		const nameRequired = this.props.intl.formatMessage(
			{ id: "validation.required", defaultMessage: "Description is required" },
			{
				field: this.props.intl.formatMessage({
					id: "name",
					defaultMessage: "Name",
				}),
			}
		);
		const kpisRequired = this.props.intl.formatMessage(
			{ id: "validation.required", defaultMessage: "KPIs is required" },
			{
				field: this.props.intl.formatMessage({
					id: "kpi",
					defaultMessage: "KPI",
				}),
			}
		);

		if (!name) {
			objError.data.errors = {
				...objError.data.errors,
				description: [nameRequired],
			};
		}
		if (kpis.length === 0) {
			objError.data.errors = {
				...objError.data.errors,
				serviceGroup: [kpisRequired],
			};
		}

		if (JSON.stringify(objError.data.errors) !== "{}") {
			this.setState({
				badRequest: true,
				badRequestResponse: objError,
			});
			return false;
		} else {
			return true;
		}
	};

	render() {
		const {
			classes,
			status,
			activeForm,
			showForm,
			submitting,
			valid,
			save,
		} = this.props;
		const { badRequest, badRequestResponse } = this.state;

		const badRequestComponent = badRequest ? (
			<BadRequest response={badRequestResponse} />
		) : null;

		return (
			<React.Fragment>
				<Dialog
					open={activeForm}
					aria-labelledby='alert-dialog-title'
					aria-describedby='alert-dialog-description'
				>
					<DialogContent className={classes.dialogContent}>
						<form
							onSubmit={(e) => {
								e.preventDefault();
								if (!!this.validation()) {
									save(
										document.getElementsByName("name")[0].value,
										this.state.value
									);
								}
							}}
						>
							<fieldset>
								<h1>
									<FormattedMessage
										id='customdash.create'
										defaultMessage='Create Custom Dashboard'
									/>
								</h1>

								{this.props.deniedEdit && <NoAuthorization />}
								{this.props.requestError && <NoSuccess />}
								<Slide>{badRequestComponent}</Slide>
								<div className='input-container'>
									<Field
										name='name'
										component={this.renderTextField}
										label={this.props.intl.formatMessage({
											id: "name",
											defaultMessage: "Role Name",
										})}
										disabled={status !== "ready" || submitting}
										fullWidth
									/>
								</div>
								<div className='input-container'>
									<label>
										<FormattedMessage id='kpi' defaultMessage='KPI' />
									</label>
									<MultiSelectFilter
										data={this.state.data}
										dataItemKey='kpiid'
										textField='name'
										value={this.state.value}
										send={this.callbackKPI}
									/>
								</div>
							</fieldset>
							<div className='form-actions-btns'>
								<div align='right'>
									{status === "loading" ? (
										<CircularProgress />
									) : (
										<>
											<Button
												className='btn'
												variant='contained'
												onClick={() => {
													showForm();
													this.props.change("name", "");
													this.setState({
														value: [],
														badRequest: false,
														badRequestResponse: null,
													});
												}}
											>
												<FormattedMessage id='cancel' defaultMessage='Cancel' />
											</Button>
											<Button
												name='save-button'
												className='btn btn-cyan'
												color='primary'
												variant='contained'
												disabled={!valid || status !== "ready" || submitting}
												type='submit'
											>
												<FormattedMessage id='save' defaultMessage='Save' />
											</Button>
										</>
									)}
								</div>
							</div>
						</form>
						{this.confirmMessage(status, save)}
					</DialogContent>
				</Dialog>
			</React.Fragment>
		);
	}
}

cdForm = reduxForm({
	form: "customDash",
	validate,
})(cdForm);

export default withStyles(styles)(injectIntl(cdForm));
